import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const QuoteGenerationRoute: RouteType = {
  name: "Quote Generation",
  path: "/quote-generation",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Quote Generation",
      component: () => import("./QuoteGenerationHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./QuoteGeneration"),
      grayBackground: true,
    },
  },
  dialogs: [],
  onEnter: async ({ rootStore }) => {
    try {
      // Load required data
      const customersStore = rootStore.customersStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const quotesStore = rootStore.quotesStore as ServiceStore;
      const quoteLineItemsStore = rootStore.quoteLineItemsStore as ServiceStore;

      // Load data if stores exist - use await to ensure data is loaded
      await Promise.all([
        customersStore?.find(),
        jobStore?.find(),
        productsStore?.find(),
        quotesStore?.find(),
        quoteLineItemsStore?.find(),
      ]);
    } catch (error) {
      console.error("Failed to load data for quote generation:", error);
    }
  },
};

export default QuoteGenerationRoute;
